import React, {Component} from 'react';
import {
    CircularProgress, 
    Button,
    Typography,
    FormControl,
    RadioGroup,
    FormControlLabel,
    Radio
} from "@material-ui/core/";
import TagManager from 'react-gtm-module';

//css
import SectionCss from './styles';
const useStyles = SectionCss();

function Section(props) {
    const classes = useStyles();

    const salvar = () => {
        props.sendForm();

        TagManager.dataLayer({
            dataLayer: {
                event: 'event',
                eventCategory: 'tokstok:fornecedores:pagamentos',
                eventAction: 'clique:botao',
                eventLabel: 'salvar'
            }
        });
    };

    const cancelamento = () => {
        props.handleCloseModel();

        TagManager.dataLayer({
            dataLayer: {
                event: 'event',
                eventCategory: 'tokstok:fornecedores:pagamentos',
                eventAction: 'clique:botao',
                eventLabel: 'cancelamento'
            }
        });
    };

    return (
        <div className={classes.root}>
            <div className={'container'} style={{maxWidth:700}}>
                <div className={classes.boxForm}>
                    <Typography variant="h5" component="h3" className={classes.title}>
                        {props.state.tipo} {props.state.title}
                    </Typography>
                    {props.state.isLoading &&
                        <div align="center">
                            <br/>
                            <CircularProgress/>
                        </div>
                    }
                    {!props.state.isLoading &&
                        <form 
                            id={"formSection"}
                            className={classes.container} 
                            noValidate 
                            autoComplete="off"
                            encType="multipart/form-data"
                        >
                            <FormControl component="fieldset">
                                <RadioGroup 
                                    aria-label="opção" 
                                    name="opcaoAntecipacao"
                                    value={props.state.descontoEscolhido}
                                    onChange={props.handleChange}
                                >
                                    {props.state.listaDescontos.map((element, i) => {  
                                        return (
                                            <FormControlLabel
                                                value={element.CD_PAGTO}
                                                key={i}
                                                control={<Radio/>} 
                                                label={element.IN_COND_PADRAO_FORNEC === "N" ? 
                                                        `${element.NR_PRAZO1} dias após a entrega, desconto de ${element.VP_DESC_ANTEC_PAGTO}%` 
                                                        : "Cancelar antecipação"
                                                    }
                                            />
                                        ) 
                                    })}
                                </RadioGroup>
                            </FormControl>
                            <br/>
                            <div className={classes.buttonAction} align="right">
                                <Button 
                                    className={classes.buttonCancelar} 
                                    onClick={cancelamento}
                                >
                                    Cancelar
                                </Button>
                                <Button variant="contained" color="primary" onClick={salvar}>
                                    {'Salvar'}
                                </Button>
                            </div>
                        </form>
                    }
                </div>
            </div>
        </div>
    );
}

export default class SectionForm extends Component {

    render() {
        return(<Section {...this.props}/>);
    }

}